(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["horecalaan-product-facts"] && !Shopify.designMode) return;
  try {
    function initHorecalaanFacts(root = document) {
  root.querySelectorAll('[data-hl-product-facts]').forEach(panel => {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const source = panel.querySelector('[data-facts-source]').content;
    const rows = panel.querySelector('[data-facts-rows]');
    const seen = new Set();
    const labels = JSON.parse(panel.dataset.labels);
    const candidates = [];
    const keys = {'taille':'dimensions','dimensions':'dimensions','afmetingen':'dimensions','kg':'weight','poids':'weight','gewicht':'weight','puissance':'supply','energie':'supply','volt':'voltage','tension':'voltage','spanning':'voltage','kw el.':'power','kw':'power','capacité':'capacity','capaciteit':'capacity','température':'temperature','temperatuur':'temperature','freq.':'frequency','phase':'phase'};
    let count = 0;
    function add(label, value) {
      label = label.replace(/\s+/g, ' ').trim().replace(/:$/, '');
      value = value.replace(/\s+/g, ' ').trim();
      const key = label.toLowerCase();
      if (!label || !value || label.length > 60 || value.length > 140 || seen.has(key) || count >= 6) return;
      seen.add(key);
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const detail = document.createElement('dd');
      term.textContent = labels[keys[key]] || label;
      detail.textContent = value;
      row.append(term, detail);
      rows.append(row);
      count++;
    }
    source.querySelectorAll('tr').forEach(row => {
      const cells = Array.from(row.querySelectorAll('th,td'));
      if (cells.length === 2) candidates.push([cells[0].textContent, cells[1].textContent]);
    });
    if (!candidates.length) source.querySelectorAll('li,p').forEach(el => {
      const text = el.textContent.trim();
      const index = text.indexOf(':');
      if (index > 0 && index < 60) candidates.push([text.slice(0, index), text.slice(index + 1)]);
    });
    
    const priority = ['dimensions','capacity','temperature','power','voltage','weight','supply','phase','frequency'];
    const rank = label => { const key = keys[label.trim().replace(/:$/, '').toLowerCase()]; const i = priority.indexOf(key); return i < 0 ? 20 : i; };
    candidates.sort((a,b) => rank(a[0]) - rank(b[0])).forEach(([label,value]) => add(label,value));
    const downloads = panel.querySelector('[data-facts-downloads]');
    const urls = new Set();
    source.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch { return; }
      if (!['https:', 'http:'].includes(url.protocol) || !/\.pdf$/i.test(url.pathname) || urls.has(url.href)) return;
      urls.add(url.href);
      const button = document.createElement('a');
      button.href = url.href;
      button.target = '_blank';
      button.rel = 'noopener';
      button.textContent = '↓ ' + (link.textContent.trim() || panel.dataset.downloadLabel);
      downloads.append(button);
    });
    downloads.hidden = !urls.size;
    if (!rows.children.length && !urls.size) panel.hidden = true;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHorecalaanFacts());
else initHorecalaanFacts();
document.addEventListener('shopify:section:load', event => initHorecalaanFacts(event.target));
  } catch(e) { console.error(e); }
})();

})();
